import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { riskStyles } from '@/lib/noShowRisk';
import { t } from '@/i18n';

const fill = (text, vars = {}) => Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), text);
export const riskReasons = (risk) => risk.reasons.map(r => fill(t(r.key), r.vars));

// No-show risk of one loading (#67); the reasons are in the tooltip.
export const RiskBadge = ({ risk, className }) => (
  <Badge variant="outline" className={cn('text-[11px]', riskStyles[risk.level], className)} title={riskReasons(risk).join(' · ')}>
    {t(`ai.risk.${risk.level}`)}
  </Badge>
);
